import { inject, observer } from 'mobx-react';
import { ReactComponent as LeftIcon } from "../../svg/align-left.svg";
import { ReactComponent as CenterIcon } from "../../svg/align-center.svg";
import { ReactComponent as RightIcon } from "../../svg/align-right.svg";
import { ReactComponent as BottomIcon } from "../../svg/align-bottom.svg";
import { ReactComponent as MiddleIcon } from "../../svg/align-middle.svg";
import { ReactComponent as TopIcon } from "../../svg/align-top.svg";
import React from 'react'

@inject('workAreaStore') @observer

class AlignMenu extends React.Component {

  handleAlignClick(type, axis){
    this.props.workAreaStore.alignLayer(type, axis)
  }

  render(){
    const layer = this.props.workAreaStore.getSelectedLayer()
    const alignMap = layer && layer.alignMap ? layer.alignMap : null
    return (
      <div className='align-menu'>
        <div className='align-menu__item'>
          <span className={'align-menu__item__text' + ` ${alignMap && alignMap.x.left ? 'selected' : ''}`} onClick={() => this.handleAlignClick('left', 'x')}>
            <LeftIcon />
            left
          </span>
          <span className={'align-menu__item__text' + ` ${alignMap && alignMap.x.center ? 'selected' : ''}`} onClick={() => this.handleAlignClick('center', 'x')}>
            <CenterIcon />
            center
          </span>
          <span className={'align-menu__item__text' + ` ${alignMap && alignMap.x.right ? 'selected' : ''}`} onClick={() => this.handleAlignClick('right', 'x')}>
            <RightIcon />
            right
          </span>
        </div>
        <div className='align-menu__item border-top'>
          <span className={'align-menu__item__text' + ` ${alignMap && alignMap.y.top ? 'selected' : ''}`} onClick={() => this.handleAlignClick('top', 'y')}>
            <TopIcon />
            top
          </span>
          <span className={'align-menu__item__text' + ` ${alignMap && alignMap.y.middle ? 'selected' : ''}`} onClick={() => this.handleAlignClick('middle', 'y')}>
            <MiddleIcon />
            middle
          </span>
          <span className={'align-menu__item__text' + ` ${alignMap && alignMap.y.bottom ? 'selected' : ''}`} onClick={() => this.handleAlignClick('bottom', 'y')}>
            <BottomIcon />
            bottom
          </span>
        </div>
      </div>
    )
  }

}

export default AlignMenu